import { Col, Row, Select } from "antd";
import { UNITS } from "../../../Common/Constants";
import { useEffect, useState } from "react";
import BATTERY from "../../../../assets/images/icons/battery.svg";
import { TEST_RIDE_CUMULATIVE } from "../../../Common/Grafana/Constants";
import panelList from "../panelList.json";
import CardCollapse from "../../../Common/CardCollapse";
import ChartFilter from "../../../Common/ChartFilter";
import PanelsRow from "../../../Common/Grafana/PanelsRow";

const BatteryPerformance = ({
  tripSummary,
  summaryList,
  baseUrl,
  baseFilterObject,
  data,
}) => {
  const summaryCount = summaryList?.length;
  const [chartType, setChartType] = useState({
    histogram: true,
    boxPlot: false,
  });
  const [batteryList, setBatteryList] = useState([]);

  useEffect(() => {
    setBatteryList([panelList?.battery[0]]);
  }, []);

  const updateChartType = (name, value) => {
    setChartType((prev) => ({ ...prev, [name]: value }));
  };

  const onSelectBattery = (selectedValues) => {
    const selectedObjects = panelList?.battery?.filter((item) =>
      selectedValues.includes(item.var_name)
    );
    setBatteryList(selectedObjects);
  };

  const subContent = (
    <>
      <Row gutter={[16, 16]} justify="space-between" className="mt05">
        <Col xs={24} sm={14} md={14} lg={14} xl={14}>
          <Select
            value={batteryList?.map((item) => item.var_name)}
            mode="tags"
            style={{ width: "100%" }}
            onChange={onSelectBattery}
            options={panelList?.battery?.map((i) => ({
              label: i.title,
              value: i.var_name,
            }))}
          />
        </Col>
        <Col
          xs={summaryCount >= 2 ? 6 : 6}
          sm={summaryCount >= 2 ? 6 : 6}
          md={summaryCount >= 2 ? 6 : 3}
          lg={summaryCount >= 2 ? 6 : 3}
          xl={summaryCount >= 2 ? 6 : 3}
        >
          <ChartFilter
            updateChartType={updateChartType}
            chartType={chartType}
            chartToHide={"timeSeries"}
          />
        </Col>
      </Row>
      <div className="grey-box mt1">
        <Row gutter={[16, 16]} justify="center">
          <Col
            xs={24}
            sm={12}
            md={summaryCount >= 2 ? 12 : 10}
            lg={summaryCount >= 2 ? 12 : 10}
            xl={summaryCount >= 2 ? 12 : 10}
          >
            Total Distance:
            <span className="ml025 bold">{tripSummary?.totalDistance}</span>
            <span className="ml025">{UNITS.KM}</span>
          </Col>
          <Col
            xs={24}
            sm={12}
            md={summaryCount >= 2 ? 12 : 10}
            lg={summaryCount >= 2 ? 12 : 10}
            xl={summaryCount >= 2 ? 12 : 10}
          >
            Total Discharge:
            <span className="ml025 bold">{tripSummary?.totalDischarge}</span>
            <span className="ml025">{UNITS.PERCENT}</span>
          </Col>
        </Row>
      </div>
    </>
  );

  return (
    <CardCollapse
      cardClassName="ride-statistic-analytics-card"
      icon={BATTERY}
      title={"Battery Performance"}
      subContent={subContent}
    >
      <Row className="pd0">
        {batteryList?.map((panel, index) => (
          <Col key={index} span={24}>
            <PanelsRow
              title={panel.title}
              url={baseUrl}
              histogramPanel={
                chartType?.histogram &&
                TEST_RIDE_CUMULATIVE.PANEL_ID[panel.var_name]["histogram"]
              }
              boxPlotPanel={
                chartType?.boxPlot &&
                TEST_RIDE_CUMULATIVE.PANEL_ID[panel.var_name]["boxPlot"]
              }
              baseFilterObject={baseFilterObject}
              variableKeys={TEST_RIDE_CUMULATIVE.BASE_VARIABLES}
              data={data}
            />
          </Col>
        ))}
      </Row>
    </CardCollapse>
  );
};

export default BatteryPerformance;
